import { trackEvent } from "analytics/client";
import React, {
  PropsWithChildren,
  useCallback,
  useMemo,
  useState,
} from "react";
import { NewLookContext } from "features/newLook/NewLook.context.ts";
import {
  ignoreFailure,
  NEW_LOOK_STORAGE_KEY,
  readIsNewLook,
} from "features/newLook/newLookStorage.ts";

const NewLookProvider = ({ children }: PropsWithChildren) => {
  const [isNewLook, setIsNewLookState] = useState(readIsNewLook);

  const setIsNewLook = useCallback((value: boolean) => {
    setIsNewLookState(value);
    ignoreFailure(() =>
      localStorage.setItem(NEW_LOOK_STORAGE_KEY, String(value))
    );
    trackEvent("New Look Toggled", { new_look: value });
  }, []);

  const value = useMemo(
    () => ({ isNewLook, setIsNewLook }),
    [isNewLook, setIsNewLook]
  );

  return (
    <NewLookContext.Provider value={value}>{children}</NewLookContext.Provider>
  );
};

export default NewLookProvider;
